export default [{
        path: '/common-web/submitOrder',
        name: 'common-web-submitOrder',
        meta: {
            title: "订单提交",
            requiresAuth: false,
        },
        component: () =>
            import ('./common-web-submitOrder/index.vue')
    },
    {
        path: '/common-web/successApply',
        name: 'common-web-successApply',
        meta: {
            title: "成功",
            requiresAuth: false,
        },
        component: () =>
            import ('./common-web-successApply/index.vue')
    },
    {
        path: '/common-web/changeWechart',
        name: 'common-web-changeWechart',
        meta: {
            title: "修改",
            requiresAuth: false,
        },
        component: () =>
            import ('./common-web-changeWechart/index.vue')
    }

]